import React from "react";

// Same geometry as MarkupEditor.paintOn: font = 2.5% of the photo width × size,
// wrapped to the right edge (never narrower than 30%), anchor pulled left when needed.
const BASE_PCT = 2.5;
const maxW = (x) => Math.max(0.3, 0.98 - x);
const anchorX = (x) => Math.min(x, 0.98 - maxW(x));

/**
 * Movable text annotations rendered OVER the image (not burned in),
 * shown in the viewer's language via pre-stored translations {en, pt}.
 * Scales with the rendered photo (container query units) and is clipped to it.
 */
export function TextOverlays({ media, lang }) {
  const ovs = media?.text_overlays;
  if (!ovs || ovs.length === 0) return null;
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none z-10" style={{ containerType: "inline-size" }} data-testid="photo-text-overlays">
      {ovs.map((o, i) => {
        const m = o.size || 1; // per-text size multiplier (pinch-to-resize in the editor)
        const x = o.x || 0;
        return (
          <span
            key={i}
            data-testid="photo-text-overlay"
            className="absolute font-semibold leading-[1.2]"
            style={{
              left: `${anchorX(x) * 100}%`,
              top: `${(o.y || 0) * 100}%`,
              maxWidth: `${maxW(x) * 100}%`,
              transform: "translateY(-0.95em)",
              whiteSpace: "pre-wrap",
              overflowWrap: "anywhere",
              color: o.color || "#DC2626",
              fontSize: `${(BASE_PCT * m).toFixed(2)}cqw`,
              textShadow: (o.color === "#FFFFFF")
                ? "0 1px 3px rgba(0,0,0,.9), 0 0 2px rgba(0,0,0,.8)"
                : "0 0 3px #fff, 0 0 3px #fff, 0 1px 2px rgba(0,0,0,.25)",
            }}
          >
            {(o.tr && o.tr[lang]) || o.text}
          </span>
        );
      })}
    </div>
  );
}
